import React, { useState } from 'react'
import { BiX } from 'react-icons/bi'
import styled from 'styled-components'

const JagadPopup = () => {

    const [popupOpen, setPopupOpen] = useState(true)

    return (
        <>
            <PopupBg className={`fixed bottom-0 right-0 z-40 transition-all transform duration-300 rounded-tl-lg overflow-hidden ${ popupOpen ? '' : 'translate-y-full' }`}>
                <div className="relative w-80  text-white p-8 ">
                    <img src="/images/logo-idea-vertical.svg" className="w-32 h-auto mb-8"/>
                    <p>Get your ticket for IdeaFest Hybrid Offline at M Bloc Space here!</p>
                    <a href="https://www.loket.com/event/ideafest-2021-offline_9493g" target="_blank" rel="noopener noreferrer"><img src="/images/button-popup.svg" className="w-52 h-auto mb-2" alt="Buy Ticket" /></a>
                    <p className="mb-12 uppercase text-optician-sans">Limited Capacity</p>
                    <img src="/images/logo-bloc.svg" className="w-12 h-auto"/>
                    <button className="absolute top-8 right-8 z-20" onClick={ () => setPopupOpen(false) }><BiX className="text-5xl" /></button>
                </div>
            </PopupBg>
            <PopupBg className={`fixed bottom-0 right-4 z-40 transition-all transform duration-300 rounded-t-lg overflow-hidden ${ popupOpen ? 'translate-y-full' : '' }`}>
                <div className="relative text-white text-sm">
                    <button onClick={ () => setPopupOpen(true) } className="text-optician-sans px-4 py-2">Buy IdeaFest Hybrid Offline Ticket</button>
                </div>
            </PopupBg>
        </>
        
    )
}

const PopupBg = styled.div`
    background: url('/images/popup-bg.png') center no-repeat;
    background-size: cover;
    box-shadow: 0 0 40px rgba(0,0,0,.3);
`

export default JagadPopup
